import { createPortal } from "react-dom";
import { X } from "lucide-react";

const ErrorBounce = ({ onClose, children }) => {
  return createPortal(
    // 1. The Backdrop (Dark Overlay)
    <div
      className="overlay before:z-9999"
      onClick={onClose} // This handles the "click outside"
    >
      {/* 2. The Modal Content */}
      <div
        className="mx-auto absolute left-0 text-center right-0 top-1 z-[99999] py-4 px-4 rounded-md w-[95%] max-w-lg bg-red-100 border-1 border-red-600"
        onClick={(e) => e.stopPropagation()} // This prevents closing when clicking INSIDE
      >
        {children}{" "}
        <X
          className="absolute right-4 cursor-pointer top-4 text-red-500"
          onClick={onClose}
        />
      </div>
    </div>,
    document.body, // Renders at the end of <body> to avoid z-index issues
  );
};

export default ErrorBounce;
